<template>
  <div class="dial-table-container">
    <!-- Left-table class changed to smmt-table  -->
    <p v-if="dialInfo.detailsSectionTitle" class="section-title">{{ dialInfo.detailsSectionTitle }}</p>
    <div v-if="dialInfo.detailsSectionTitle" class="row-2 flex-row">
      <div class="left-table company-car-table-dealer" v-if="dialInfo.firstDetailSection && showTables">
        <div class="left-table-container">
          <div v-for="(row, rowIndex) in dialInfo.firstDetailSection" :key="`row-${rowIndex}`">
            <div v-if="row.label" :class="['row', row.label]">
              <div class="header" v-if="row.label">{{ row.label }}</div>
              <div v-for="(data, index) in row.data" :key="`data-${index}`">
                <div :class="['data', data.isMetricAppealable ? 'appealable' : '']" v-if="data.isRowAppealable">
                  {{ data.data }}
                  <div v-if="data.isMetricAppealable && data.appeal && displayResults">
                    <Multiselect
                      class="multiselect single"
                      v-model="data.selection"
                      ref="multiselect"
                      :options="data.appeal"
                      :searchable="false"
                      :showLabels="false"
                      label="label"
                      track-by="value"
                      :preselect-first="true"
                      :allowEmpty="false"
                      :disabled="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-for="(row, rowIndex) in appealInfo" :key="`appeal-${rowIndex}`">
            <div v-if="row.label" class="row">
              <div class="header" v-if="row.label">{{ row.label }}</div>
              <div
                :class="['data', data.appealable ? 'multi' : '']"
                v-for="(data, index) in row.data"
                :key="`data-${index}`"
              >
                <div v-if="data.id === 'multiselect' && data.appealable">
                  <Multiselect
                    class="multiselect single small"
                    v-model="data.selection"
                    :options="data.appeal"
                    :searchable="false"
                    :showLabels="false"
                    label="label"
                    track-by="value"
                    :preselect-first="true"
                    :disabled="disabled"
                    :allowEmpty="false"
                  />
                </div>
                <div
                  class="input-container"
                  v-if="data.id === 'reasonInput' && appealInfo[0].data[index].selection.value === 'Y'"
                >
                  <GInput
                    v-model="data.data"
                    :readonly="disabled"
                    placeholder="Enter appeal reason..."
                    type="textarea"
                    :class="['input', data.data === null || data.data === '' ? 'required' : '']"
                    required
                  />
                </div>
                <div
                  class="input-container"
                  v-if="data.id === 'reviewInput' && appealInfo[0].data[index].selection.value === 'Y'"
                >
                  <GInput v-model="data.data" placeholder="" readonly type="textarea" class="input" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GInput from '@/components/GComponents/GInput.vue';

export default {
  name: 'SMMTAppeal',
  components: {
    Multiselect,
    GInput,
  },
  props: {
    dialInfo: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    displayResults: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      replyInputRef: null,
      appealInfo: null,
      showTables: false,
    };
  },
  computed: {},
  watch: {
    appealInfo(val) {
      this.dialInfo.appealInfo = val;
    },
    deep: true,
  },
  methods: {
    modifyAppealInfoRows() {
      const appealableArray = this.dialInfo.appealableRows;

      if (this.dialInfo.detailsSectionTitle) {
        this.dialInfo.firstDetailSection.forEach((row) => {
          row.data.forEach((data) => {
            const appealable = appealableArray.find((appealableRow) => appealableRow.ordinal === data.ordinal);
            if (appealable && appealable.isRowAppealable) {
              this.$set(data, 'isRowAppealable', true);
            } else {
              this.$set(data, 'isRowAppealable', false);
            }
          });
        });
      }
    },
    createAppealInfo() {
      this.appealInfo = [
        {
          label: 'Appeal',
          data: [],
        },
        {
          label: 'Appeal Reason',
          data: [],
        },
        {
          label: 'Review Reason',
          data: [],
        },
      ];
      if (this.dialInfo.detailsSectionTitle) {
        this.dialInfo.firstDetailSection[0].data.forEach((row, index) => {
          if (row.data.length > 0 && row.isRowAppealable) {
            this.appealInfo[0].data.push({
              id: 'multiselect',
              selection: {
                label: 'No',
                value: 'N',
              },
              ordinal: this.dialInfo.appealableRows[index].ordinal,
              appealable: this.dialInfo.appealableRows[index].isRowAppealable,
              appeal: [
                {
                  label: 'No',
                  value: 'N',
                },
                {
                  label: 'Yes',
                  value: 'Y',
                },
              ],
            });
            this.appealInfo[1].data.push({
              id: 'reasonInput',
              data: null,
            });
            this.appealInfo[2].data.push({
              ordinal: this.dialInfo.appealableRows[index].ordinal,
              id: 'reviewInput',
              data: null,
            });
          }
        });
      }
    },
    updateAppealInfo() {
      const appealableArray = this.dialInfo.appealableDialResults;

      this.appealInfo[0].data.forEach((item, index) => {
        if (item.ordinal) {
          const appealable = appealableArray.find((row) => row.ordinal === item.ordinal);
          if (appealable) {
            item.selection = {
              label: appealable.appealResult === 'Y' ? 'Yes' : 'No',
              value: appealable.appealResult,
            };
            item.appeal = [
              {
                label: 'No',
                value: 'N',
              },
              {
                label: 'Yes',
                value: 'Y',
              },
            ];
          }
          const existingRow = appealableArray.find((row) => row.ordinal === item.ordinal);
          if (existingRow) {
            this.appealInfo[1].data[index].data = existingRow.appealReason;
            this.appealInfo[2].data[index].data = existingRow.reviewReason;
          }
        }
      });
    },
    // This method is used to apply the multiselect dropdown functionality at the metric level on appealable rows.
    updateTableInfo() {
      const appealableOrdinals = [];

      const appealableArray = this.dialInfo.appealableDialResults;
      const { appealableRows } = this.dialInfo;

      appealableArray.forEach((row) => {
        if (row.appealResult === 'Y') {
          if (appealableRows.find((item) => item.ordinal === row.ordinal)) {
            appealableOrdinals.push(row.ordinal);
          }
        }
      });
      this.dialInfo.firstDetailSection.forEach((row) => {
        row.data.forEach((data) => {
          if (appealableOrdinals.includes(data.ordinal)) {
            this.$set(data, 'appeal', [
              { label: 'No Actions', value: 'NA' },
              {
                label: 'Approved',
                value: 'Y',
              },
              {
                label: 'Deny',
                value: 'N',
              },
            ]);
            this.$set(data, 'selection', {
              label: 'No Actions',
              value: 'NA',
            });
          }
        });
      });
    },
    showReviewInfo() {
      this.dialInfo.appealableDialResults.forEach((result) => {
        this.appealInfo[2].data.forEach((item, index) => {
          if (item.ordinal === result.ordinal && result.dialReviews.length > 0) {
            this.appealInfo[2].data[index].data = result.dialReviews[0].reviewReason;
          }
        });
        this.dialInfo.firstDetailSection.forEach((row) => {
          const matchingColumn = result.dialReviews.find((review) => review.attributeId === row.dataName);
          if (matchingColumn) {
            row.data.forEach((data) => {
              if (data.ordinal === result.ordinal) {
                if (matchingColumn.reviewResult === 'Y') {
                  data.selection = {
                    label: 'Approved',
                    value: 'Y',
                  };
                } else {
                  data.selection = {
                    label: 'Denied',
                    value: 'N',
                  };
                }
              }
            });
          }
        });
      });
    },
  },
  created() {
    this.modifyAppealInfoRows();
    this.createAppealInfo();
    if (this.disabled) {
      this.updateAppealInfo();
      this.updateTableInfo();
      if (this.dialInfo.appealableDialResults[0].dialReviews.length > 0 && this.displayResults) {
        this.showReviewInfo();
      }
    }
    this.showTables = true;
  },
};
</script>

<style lang="scss" scoped>
.dial-table-container {
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  margin-left: 30px;
}
.row-2 {
  margin: 0 -30px;
}
.left-table {
  overflow: scroll;
  max-height: 300px;
  margin-right: 0px;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 5px;
  }
  &::-webkit-scrollbar:horizontal {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 1px solid white;
    background-color: $input-readonly-text;
  }
  &:read-only::-webkit-scrollbar-thumb {
    border: 1px solid $input-readonly;
  }
  .header {
    text-align: center;
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .VIN {
    .header {
      padding-left: 30px !important;
    }
    .data {
      padding-left: 30px !important;
    }
  }
}
.section-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 26px;
  color: $primary;
  text-transform: uppercase;
  text-align: left;
  margin: 40px 0px;
}
.modified-row {
  display: flex;
}
.modified-data {
  color: #1d1d1b;
  font-size: 14px;
  padding: 10px 0px;
  text-align: center;
  width: 78px;
}

::v-deep .multiselect {
  max-width: 140px !important;
  &.small {
    max-width: 80px !important;
  }
  margin-left: 10px;

  &__tags {
    min-height: 38px !important;
    padding-top: 8px !important;
  }
  &__select {
    height: 36px !important;
  }
}

.input-container {
  width: 200px;
  display: flex;
  ::v-deep .g-input {
    height: 40px;
    margin: 0;
    textarea {
      max-width: 200px;
      resize: none;
      max-height: 40px;
      padding: 3px 8px;
    }
  }
  input {
    width: 100%;
    padding: 0 0 0 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
  }
  .required {
    border: 1px solid $error;
  }
}

.appealable {
  color: red !important;
  font-weight: bold;
}
.multi {
  padding: 8px 14px !important;
  height: 34px !important;
}
</style>
